import {StringSizeInfo} from './types'
var {createCanvas} = require("canvas");

const fontSizingCanvas = createCanvas(1,1);

/**
 * Use a virtual canvas to get the size of text
 * @param text 
 * @param rotation in degrees
 * @param font name of font
 * @param fontSize 
 * @returns stringSizeInfo
 */
export function getTextSizing(text:string,
	                   rotation:number,
					   font:string,
					   fontSize:number):StringSizeInfo {
    if(fontSize===0) return {width:0,height:0,area:0} // Protec
    
    const canvas = fontSizingCanvas; // Global var for performance
    const context = canvas.getContext("2d");
    context.font = fontSize + "px " + font;
    const metrics = context.measureText(text);

    const height = textHeight(metrics);
    const width = textWidth(metrics);

    return {
        width:rotatedRectangleWidth(height, width, rotation),
        height:rotatedRectangleHeight(height, width, rotation),
        area:height*width,
    };
}

/**
 * Finds the width of a rectangle after rotation
 * @param height
 * @param width 
 * @param rotation in degrees
 */
function rotatedRectangleWidth(height:number, width:number, rotation:number):number {
    const diagonalLength = Math.sqrt(height**2+width**2)

    const radialRotation = (rotation/180)*Math.PI

    // In the triangle made from height, width, diagonal
    // find the angle: diagonal, height
    const innerAngle = Math.atan(width/height)

    // Use that angle to create a new triangle
    // With sides and [angles]: rotWidth, [90-cTA], 
    // diagonal, [cTA], _,[90]
    const constructedTriangleAngle = innerAngle + radialRotation

    return Math.abs(Math.sin(constructedTriangleAngle)*diagonalLength)
}

/**
 * Finds the height of a rectangle after rotation
 * @param height
 * @param width 
 * @param rotation in degrees
 */
function rotatedRectangleHeight(height:number, width:number, rotation:number) {
    return rotatedRectangleWidth(width,height,rotation)
}

function textHeight(metrics) {
    return Math.abs(metrics.actualBoundingBoxDescent) +
           Math.abs(metrics.actualBoundingBoxAscent);
}

function textWidth(metrics) {
    return Math.abs(metrics.actualBoundingBoxLeft) +
		   Math.abs(metrics.actualBoundingBoxRight);
}